export function InputFilterDisease ({ name, diseases, setDiseases }) {
  const HandleSelect = () => {
    const newDiseases = diseases

    newDiseases.push(name)
    setDiseases(newDiseases)
  }

  return (
    <div className='flex gap-1 items-center'>
    <input onClick={HandleSelect} type="checkbox" name="" id="" /> <p>{name}</p>
    </div>
  )
}
